import { NextSeo } from 'next-seo';

//screens
import { PurchaseOrderFollowUp } from '@/screens/Agents/PurchaseOrderFollowUp';

//data-helpers
import { JsonLd, Organization } from '@/datafiles/micro-data';

export default function PurchaseOrderFollowUpPage() {
  return (
    <>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        canonical="https://loadsmart.com/ai/purchase-order-follow-up/"
        title="Purchase Order Follow-Up Agent | Loadsmart AI"
        description="Finds purchase orders that are due with no dock appointment, or with a booking that won’t arrive in time, and gets the supplier or carrier to ship, book or rebook before stock runs short."
        openGraph={{
          url: 'https://loadsmart.com/ai/purchase-order-follow-up/',
        }}
      />
      <JsonLd data={Organization} />
      <PurchaseOrderFollowUp />
    </>
  );
}
